import { forwardRef } from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';

export const EmailStep = forwardRef(function EmailStep(
  { email, onEmailChange, onSubmit, loading, error, validEmail },
  emailRef,
) {
  return (
    <form onSubmit={onSubmit} className="w-full">
      <div className="lm-kicker">Welcome back</div>
      <h2 className="lm-h2">Sign in</h2>
      <p className="lm-body">Enter your email and we will send you a sign-in code. No password to remember.</p>

      <div className="lm-field">
        <label htmlFor="login-email">Email</label>
        <input
          id="login-email"
          ref={emailRef}
          type="email"
          className="lm-input"
          value={email}
          onChange={onEmailChange}
          placeholder="you@company.com"
          autoComplete="email"
          data-testid="email-input"
        />
      </div>

      {error && (
        <p className="lm-error" data-testid="error-msg">
          <AlertCircle className="w-4 h-4 shrink-0" />{error}
        </p>
      )}

      <button type="submit" className="lm-btn" disabled={!validEmail || loading} data-testid="email-submit">
        {loading ? (<><Loader2 className="w-4 h-4 animate-spin" />Sending code…</>) : 'Continue'}
      </button>

      <div className="lm-divider" />
      <p className="lm-foot">
        New to Lumyn?{' '}
        <span className="lm-link" style={{ cursor: 'default' }}>Ask your trainer for an invitation</span>.
      </p>
    </form>
  );
});
